import { IDefineCommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { ISurveyQuestionItemDTO } from '../../major_explorer_interface';
import { IGoal } from '../../major_explorer_interface';

angular
  .module('major-explorer-data')
  .factory('saveItemCommand', (defineCommand: IDefineCommand, $http: ng.IHttpService) => {
    return defineCommand('saveItemCommand', (deferred: ng.IDeferred<any>, item: ISurveyQuestionItemDTO) => {
      const options = item._options || item.options;
      const payload = {
        actions: {}
      };

      _4.forEach(options, (option: IGoal) => {
        payload.actions[option.id] = option._action;
      });

      $http
        .post(`item/${item.id}/`, payload)
        .then(({ data }) => {
          deferred.resolve(data);
        })
        .catch(() => {
          deferred.reject('failed to save action, please attempt again');
        });
    });
  });



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/data/commands/save_item_command.ts